import { render, staticRenderFns } from "./MovementBulkUploadModal.vue?vue&type=template&id=9b3b33d4"
import script from "./MovementBulkUploadModal.vue?vue&type=script&lang=js"
export * from "./MovementBulkUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports